import { useState, useEffect } from "react";
import LandingPage from "./LandingPage";
import CGVPage from "./CGVPage";
import MatriceA from "./MatriceA";
import MatriceB from "./MatriceB";
import MatriceC from "./MatriceC";
import MatriceD from "./MatriceD";



export default function App() {
  const [DEV_MODE, setDevMode] = useState(false);
  const [page, setPage] = useState("home");
  const [questionnaire, setQuestionnaire] = useState(null);
  const [paid, setPaid] = useState(sessionStorage.getItem("mk_paid") === "1");
  const [verifying, setVerifying] = useState(false);
  const [devChecking, setDevChecking] = useState(!!new URLSearchParams(window.location.search).get("dev"));

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pwd = params.get("dev");
    if (pwd) {
      fetch("/api/dev-auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: pwd })
      })
        .then(r => r.json())
        .then(data => {
          if (data.token) {
            setDevMode(true);
            setPaid(true);
            sessionStorage.setItem("mk_paid", "1");
            window.history.replaceState({}, "", "/");
          }
          setDevChecking(false);
        })
        .catch(() => { setDevChecking(false); });
    }
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    if (path === "/cgv") { setPage("cgv"); return; }

    // Retour après paiement Stripe
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    const q = params.get("q");
    if (sessionId && q) {
      setVerifying(true);
      fetch("/api/verify-payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionId })
      })
        .then(r => r.json())
        .then(data => {
          if (data.paid) {
            setPaid(true);
            setQuestionnaire(q);
            setPage("questionnaire");
            window.history.replaceState({}, "", "/");
          } else {
            setPage("home");
          }
          setVerifying(false);
        })
        .catch(() => { setPage("home"); setVerifying(false); });
    }
  }, []);

  function goHome() {
    setPage("home");
    setQuestionnaire(null);
    setPaid(false);
    sessionStorage.removeItem("mk_paid");
    window.scrollTo(0, 0);
  }

  async function startQuestionnaire(key) {
    if (DEV_MODE || paid) {
      setQuestionnaire(key);
      setPage("questionnaire");
      window.scrollTo(0, 0);
      return;
    }
    // Lancer paiement Stripe
    const successUrl = window.location.origin + "/?session_id={CHECKOUT_SESSION_ID}&q=" + key;
    const cancelUrl = window.location.origin + "/";
    try {
      const res = await fetch("/api/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ successUrl, cancelUrl })
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
    } catch (e) {
      alert("Erreur lors de la redirection vers le paiement. Réessayez.");
    }
  }

  function showCGV() { setPage("cgv"); window.scrollTo(0, 0); }

  function QuestionnaireSelector() {
    const TEAL = "#1B6B6B", GOLD = "#E8C87A", WHITE = "#FFFFFF", DARK = "#0D2B2B", TEAL_PALE = "#E0F4F4";
    return (
      <div style={{ fontFamily: "system-ui", background: "#F7FAFA", minHeight: "100vh" }}>
        <div style={{ background: `linear-gradient(135deg, ${DARK}, ${TEAL})`, padding: "28px 20px 24px", borderRadius: "0 0 24px 24px" }}>
          <button onClick={goHome} style={{ background: "none", border: "none", cursor: "pointer", color: "rgba(255,255,255,0.6)", fontSize: 14, marginBottom: 16, fontFamily: "system-ui" }}>
            ← Retour à l'accueil
          </button>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, color: GOLD, textTransform: "uppercase", marginBottom: 8 }}>Questionnaire Profil Enfant</div>
          <div style={{ fontSize: 26, fontWeight: 800, color: WHITE, marginBottom: 6, fontFamily: "Georgia, serif" }}>Quel est l'âge de votre enfant ?</div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.65)" }}>Choisissez le questionnaire adapté</div>
        </div>
        <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 16, maxWidth: 600, margin: "0 auto" }}>
          {[
            { age: "5 — 7 ans", label: "Questionnaire A", sub: "100% parents · 15 questions", color: "#6B4FBB", bg: "#EDE8FF", key: "A" },
            { age: "8 — 11 ans", label: "Questionnaire B", sub: "Enfant + parents · 20 questions", color: TEAL, bg: TEAL_PALE, key: "B" },
            { age: "12 — 14 ans", label: "Questionnaire C", sub: "Ado + parents · 20 questions", color: "#1B5E7D", bg: "#D4EAF5", key: "C" },
            { age: "15 — 17 ans", label: "Questionnaire D", sub: "Ado + parents · 21 questions", color: "#1B5E20", bg: "#E8F5E9", key: "D" },
          ].map((q, i) => (
            <div key={i} onClick={() => startQuestionnaire(q.key)}
              style={{ background: WHITE, borderRadius: 16, padding: "20px 24px", cursor: "pointer", border: "2px solid " + q.bg, display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "0 4px 16px rgba(27,107,107,0.06)" }}>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: q.color, textTransform: "uppercase", marginBottom: 4 }}>{q.label}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: DARK, marginBottom: 4, fontFamily: "Georgia, serif" }}>{q.age}</div>
                <div style={{ fontSize: 13, color: "#8B7BB5" }}>{q.sub}</div>
              </div>
              <div style={{ background: q.color, color: WHITE, borderRadius: 100, padding: "8px 16px", fontSize: 13, fontWeight: 700 }}>
                {DEV_MODE || paid ? "Commencer →" : "Payer et commencer →"}
              </div>
            </div>
          ))}
        </div>
        {DEV_MODE && (
          <div style={{ textAlign: "center", fontSize: 11, color: "#888", marginTop: 8 }}>
            Mode développeur actif — paiement désactivé
          </div>
        )}
      </div>
    );
  }

  if (devChecking) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>⏳</div>
  );

  if (verifying) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", fontFamily: "system-ui", color: "#1B6B6B", fontSize: 18 }}>
      ⏳ Vérification du paiement...
    </div>
  );

  if (page === "cgv") return <CGVPage onBack={goHome} />;

  if (page === "questionnaire") {
    if (!questionnaire) return <QuestionnaireSelector />;
    if (questionnaire === "A") return <MatriceA onBack={goHome} />;
    if (questionnaire === "B") return <MatriceB onBack={goHome} />;
    if (questionnaire === "C") return <MatriceC onBack={goHome} />;
    if (questionnaire === "D") return <MatriceD onBack={goHome} />;
  }

  return <LandingPage onStart={() => setPage("questionnaire")} onCGV={showCGV} />;
}
